export default {
    PARAFFINBLOCK_ARCHIVE: {
        id: 'operation.entity.portion.archive'
    },
    PARAFFINBLOCK_CUT: {
        id: 'operation.entity.portion.cut'
    },
    PARAFFINBLOCK_SUBPORTION_CUT: {
        id: 'operation.entity.subportion.cut'
    },
    PARAFFINBLOCK_FROM_TISSUE_PROCESSOR: {
        id: 'operation.entity.portion.process'
    },
    PARAFFINBLOCK_MAKE: {
        id: 'operation.entity.portion.make'
    },
    PARAFFINBLOCK_TO_TISSUE_PROCESSOR: {
        id: 'operation.entity.portion.to-tissue-processor'
    },
    PARAFFINBLOCK_UNARCHIVE_TO_CUT: {
        id: 'operation.entity.portion.unarchive-to-cut'
    },
    PARAFFINBLOCK_UNARCHIVE_TO_MAKE: {
        id: 'operation.entity.portion.unarchive-to-remake'
    },
    SLIDE_ARCHIVE: {
        id: 'operation.entity.subportion.archive'
    },
    SLIDE_COVER: {
        id: 'operation.entity.subportion.cover'
    },
    SLIDE_TO_STAINER: {
        id: 'operation.entity.subportion.to-stainer'
    },
    SLIDE_STAIN: {
        id: 'operation.entity.subportion.stain'
    },
    SLIDE_TO_COVERING: {
        id: 'operation.entity.subportion.to-covering'
    },
    SLIDE_TO_PATHOLOGIST: {
        id: 'operation.entity.subportion.to-pathologist'
    },
    SLIDE_TO_SCANNER: {
        id: 'operation.entity.subportion.to-scanner'
    },
    SLIDE_UNARCHIVE_TO_PRINT: {
        id: 'operation.entity.subportion.unarchive-to-print'
    },
    SLIDE_UNARCHIVE_TO_STAIN: {
        id: 'operation.entity.subportion.unarchive-to-stain'
    },
    SLIDE_UNARCHIVE_TO_SCAN: {
        id: 'operation.entity.subportion.unarchive-to-scan'
    },
    SLIDE_SCAN: {
        id: 'operation.entity.subportion.scan'
    },
    SAMPLE_ARCHIVE: {
        id: 'operation.entity.sample.archive'
    }
}
